import { useMemo } from 'react';

import { AnswerQuestion, AskQuestion, QuestionAndAnswerFilters, QuestionThread } from './partials';

import useQuestionAndAnswer from './useQuestionAndAnswer';
import { EUserType, IQuestion } from '@src/types';

import styles from './questionAndAnswer.module.scss';
import LoaderIcon from '@src/assets/icons/LoaderIcon';

const QuestionAndAnswer = () => {
  const {
    currentPeerType,
    showFilter,
    sortFilter,
    questionsListRef,
    filteredQuestions,
    isLoading,
    selectedQuestion,
    isAnswerBoxOpened,
    openedAnserSections,
    isReplyingPrivately,
    isAnswerQuestionsButtonEnabled,
    isSubmitQuestionsButtonEnabled,

    setShowFilter,
    setSortFilter,
    handleOpenAnswerBox,
    handleCloseAnswerBox,
    handleToggleAnswerSection,
    handleReplayPrivatelyCheck,
  } = useQuestionAndAnswer();

  const FooterComponent = useMemo(() => {
    if (isAnswerBoxOpened && selectedQuestion && isAnswerQuestionsButtonEnabled) {
      return (
        <AnswerQuestion
          question={selectedQuestion}
          isReplyingPrivately={isReplyingPrivately}
          handleOnClose={handleCloseAnswerBox}
          handleReplayPrivatelyCheck={handleReplayPrivatelyCheck}
        />
      );
    } else if (isSubmitQuestionsButtonEnabled) {
      return <AskQuestion />;
    }
    return null;
  }, [
    selectedQuestion,
    isAnswerBoxOpened,
    isReplyingPrivately,
    isAnswerQuestionsButtonEnabled,
    isSubmitQuestionsButtonEnabled,
    handleCloseAnswerBox,
    handleReplayPrivatelyCheck,
  ]);

  return (
    <div className={styles.questionsContainer}>
      <div className={styles.filtersContainer}>
        <QuestionAndAnswerFilters
          currentPeerType={currentPeerType as EUserType}
          showValue={showFilter}
          sortValue={sortFilter}
          onShowChange={setShowFilter}
          onSortChange={setSortFilter}
        />
      </div>
      <div className={styles.questionsListContainer} ref={questionsListRef}>
        {isLoading && (
          <div className={styles.loaderWrapper}>
            <LoaderIcon />
          </div>
        )}
        {filteredQuestions?.map((question: IQuestion) => (
          <QuestionThread
            key={question.id}
            question={question}
            isAnswerSectionOpened={openedAnserSections[question.id] || false}
            handleToggleAnswerSection={() => handleToggleAnswerSection(question.id)}
            handleOpenAnswerBox={(answerType) => handleOpenAnswerBox({ question, answerType })}
          />
        ))}
      </div>
      {FooterComponent}
    </div>
  );
};

export default QuestionAndAnswer;
